import { createRoot } from 'react-dom/client';
import envInfoLabel from '@cld/env-info-label';
import { App } from './App.js';

envInfoLabel();

const root = createRoot(document.getElementById('standalone')!);

root.render(<App />);
